import lfRequest from '@/service/index'


export function createData(url: string, addData: any) {
  return lfRequest.post<any>({
    url: url,
    data: addData
  })
}

export function updateData(url: string, editData: any) {
  return lfRequest.put<any>({
    url: url,
    data: editData
  })
}

export function deleteData(url: string) {
  return lfRequest.delete<any>({
    url: url
  })
}